const videos = document.querySelectorAll("[data-youtube-src]"); // Select all video elements using querySelectorAll
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const video = entry.target;
        video.setAttribute("src", video.getAttribute("data-youtube-src")); // Set the source attribute of the video element
        observer.unobserve(video);
      }
    });
  },
  { threshold: [0] }
);
videos.forEach((video) => {
  observer.observe(video);
});
